export function svgRenderInfo() {
  this.fCanvasPanel = null;
  this.fCurDoc = null;
  this.fPublishPanel = null;
  this.fCropToChart = null;
  this.fCreateAlt = null;
  this.fCreatePreview = null;
  this.fTransparent = null;
  this.fHires = null;
  this.fOverwrite = null;
}
